import { observer } from 'mobx-react';
import { View, ViewHeader } from '../../../../core/components/Index'
import useAsyncEffect from 'use-async-effect';
import { useNavigate } from 'react-router-dom';
import { Appl } from '../../../../core/Appl';
import ReleaseNotesViewModel from './ReleaseNotesViewModel';
import Markdown from 'react-markdown';
import 'github-markdown-css/github-markdown.css';
import { formatDate } from '../../../../core/services/Helper';

const ReleaseNotesView = observer(() => {
  const vm = Appl.Services.get<ReleaseNotesViewModel>('ReleaseNotesViewModel');
  vm.navigate = useNavigate();
  useAsyncEffect(async () => {
    await vm.initAsync();
  }, []);

  return (
    <>
      <View
        id="ReleaseNotesView"
        pageTitle={vm.pageTitle}
        showMenuBar={false}
      >
        <ViewHeader title={vm.pageTitle} description={vm.pageDescription} helpPageId="" backUrl="" />
        {vm.model && vm.model.map((releaseNote, index) => {
          return (
            <div key={`ReleaseNote${index}`} className="space-y-6 mt-2">
              <h1 className="text-22px font-semibold mb-0 text-black">Release {releaseNote.buildNbr}</h1>
              <label>{formatDate(releaseNote.buildDate)}</label>
              <div className="markdown-body p-4 mb-2">
                <Markdown>{releaseNote.buildNotes}</Markdown>
              </div>
            </div>
          );
        })}
      </View >
    </>
  );
});

export default ReleaseNotesView;
